import { toast } from "react-toastify";
import { post, put, get, remove } from "sr/utils/axios";
import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { Requirement } from "sr/models/Requirement";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";

export const createRequirement = async (postData: any) => {
  try {
    return await post<ApiResponse<Requirement>>("/corporate/requirements", postData).then((res) => {
      if (res.success === true) {
        toast.success(res.message || "Requirement created successfully");
        return res;
      } else {
        toast.error(res.error?.message || "Failed to create requirement");
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const updateRequirement = async (id: string, postData: any) => {
  try {
    return await put<ApiResponse<Requirement>>(`/corporate/requirements/${id}`, postData).then((res) => {
      if (res.success === true) {
        toast.success(res.message || "Requirement updated successfully");
        return res;
      } else {
        toast.error(res.error?.message || "Failed to update requirement");
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const getRequirements = async (params: any = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    return await get<ApiResponse<Requirement[]>>(
      `/corporate/requirements${queryParams ? `?${queryParams}` : ""}`
    ).then((res) => {
      if (res.success === true) {
        return res;
      } else {
        toast.error(res.error?.message || "Failed to fetch requirements");
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const getRequirementDetails = async (id: string) => {
  try {
    return await get<ApiResponse<Requirement>>(`/corporate/requirements/${id}`).then((res) => {
      if (res.success === true) {
        return res;
      } else if (res.data) {
        console.warn("API returned 500 but with usable data:", res);
        return res;
      } else {
        toast.error(res.error?.message || "Failed to fetch requirement details");
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};

export const deleteRequirement = async (id: string) => {
  try {
    return await remove<ApiResponse<[]>>(`/corporate/requirements/${id}`).then((res) => {
      if (res.success === true) {
        SuccessMessage("API.SUCCESS.CORPORATE.REQUIREMENT.DELETE");
        return res;
      } else {
        HandleApiError(res.error?.message);
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
  }
};
